import type { CollectionModelFieldNestedList } from '@ikegps/core-shared';
import { MultiListInput } from '../../../components/input/multi.list.input';
import type { MithrilVNode } from '../../../mithril';
import { NestedListChooserState } from '../../multi.list.chooser/nested.list.chooser.state';
import type { CollectionEditCtrl } from '../collection.view.ctrl';
import type { CollectionFieldView } from './field.view';

export const NestedListFieldView: CollectionFieldView<CollectionModelFieldNestedList> = {
	viewInline(field: CollectionModelFieldNestedList): string {
		return field.hasValue() ? field.displayValue : null;
	},

	viewDetail(field: CollectionModelFieldNestedList): MithrilVNode {
		return null;
	},

	viewEdit(field: CollectionModelFieldNestedList, ctrl: CollectionEditCtrl): MithrilVNode | string {
		let inputState = ctrl.changeState.getState(field.id) as NestedListChooserState;
		if (inputState == null) {
			inputState = new NestedListChooserState(field);
			inputState.onValue(() => setManualValue(field, inputState));
			ctrl.changeState.addState(field.id, inputState);
		}

		return MultiListInput.view(inputState);
	},
};

function setManualValue(field: CollectionModelFieldNestedList, inputState: NestedListChooserState) {
	const value = inputState.value;
	if (value != null) {
		field.Mutator.manual(Array.from(value));
	} else {
		field.Mutator.clear();
	}
}
